// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular.json`.

import { config } from "config";

export const environment = {
  production: false,
  apiURL: config.apiUrl,
  firebaseConfig : {
    apiKey: "AIzaSyD5TSwiNcX0RW53wXQimMoJmHPXDli2dBI",
    authDomain: "og-push-notification-3ac56.firebaseapp.com",
    projectId: "og-push-notification-3ac56",
    storageBucket: "og-push-notification-3ac56.appspot.com",
    messagingSenderId: "85488537624",
    appId: "1:85488537624:web:4f744bdbba5945cda3336d",
    measurementId: "G-0VQJC91D4Y"
  }
};
// gmail:testsb8123@gmail.com
// password:gm@1998(code word)

// apiKey: "AIzaSyBXxxXM8F5o2wnD0iWZQF89itZTr30zCpw",
// authDomain: "pushnotification-ae019.firebaseapp.com",
// projectId: "pushnotification-ae019",
// storageBucket: "pushnotification-ae019.appspot.com",
// messagingSenderId: "113566835865",
// appId: "1:113566835865:web:2cdfcd5f931313653dc408",
// measurementId: "G-EM74F15L8Q"